///////////////////////////////////////////////////////////////////
//
// Event Listeners
//
///////////////////////////////////////////////////////////////////

(function() {
  document.addEventListener('turbolinks:load', (e) => {
    if (document.querySelector('#js-confirmation-fields')) {
      document.querySelector('.process-review-form').addEventListener('click', (e) => {
        const confirmationFields = new ConfirmationFields(),
              target = e.target;

        if (confirmationElement(target)) {
          if (target.id === 'js-confirm-dual-language-learning' ||
              target.id === 'js-confirm-special-needs') {
            confirmationFields.quickSave();
          }
        }
      });
    }
  });



  ///////////////////////////////////////////////////////////////////
  //
  // Constructors
  //
  ///////////////////////////////////////////////////////////////////

  function ConfirmationFields() {
    this.quickSaveButton = document.querySelector('#js-quick-save');
  }



  ///////////////////////////////////////////////////////////////////
  //
  // Prototype Definitions
  //
  ///////////////////////////////////////////////////////////////////

  ///////////////////////////////////////////////
  //
  // Description - Spoofs click of Quick Save button invoked whenever
  //               a confirmation field checkbox is clicked.
  //
  //
  ConfirmationFields.prototype.quickSave = function() {
    this.quickSaveButton.click();
  };



  ///////////////////////////////////////////////////////////////////
  //
  // Callbacks
  //
  ///////////////////////////////////////////////////////////////////

  ///////////////////////////////////////////////
  //
  // Description - Determines whether or not a confirmation
  //               checkbox is the event target
  //
  function confirmationElement(eventTarget) {
    return (eventTarget.id === 'js-confirm-dual-language-learning' ||
            eventTarget.id === 'js-confirm-special-needs');
  }
}());
